/**
 * Tipos de contratación disponibles en Shelf.
 *
 * El `value` se guarda tal cual en `TradeContract.type`, y la app móvil lo muestra
 * con su propio mapa de etiquetas usando `typeMap[type] || type`. Por eso los tipos
 * nuevos usan directamente su nombre legible como valor: se ven correctamente en
 * shelf-app sin tener que publicar una versión nueva de la app.
 */
export const CONTRACT_TYPES = [
    { label: 'Cabezal', value: 'cabezal', color: 'green' },
    { label: 'Isla', value: 'isla', color: 'gold' },
    { label: 'Parrillera', value: 'parrillera', color: 'blue' },
    { label: 'Checkout', value: 'checkout', color: 'orange' },
    { label: 'Cross Category', value: 'cross_category', color: 'cyan' },
    { label: 'Bloque de Marca', value: 'bloque_de_marca', color: 'pink' },
    { label: 'Exhibidor de Piso', value: 'exhibidor_de_piso', color: 'default' },
    { label: 'Caja de Luz', value: 'Caja de Luz', color: 'volcano' },
    { label: 'Cubrepaleta', value: 'Cubrepaleta', color: 'magenta' },
    { label: 'Paleta', value: 'Paleta', color: 'lime' },
    { label: 'Pantalla LED', value: 'Pantalla LED', color: 'geekblue' },
    { label: 'Torre con Cubrepaleta', value: 'Torre con Cubrepaleta', color: 'purple' },
    { label: 'Torre sin Cubrepaleta', value: 'Torre sin Cubrepaleta', color: 'purple' },
    { label: 'Valla Interna', value: 'Valla Interna', color: 'gold' },
    { label: 'Valla Externa', value: 'Valla Externa', color: 'orange' }
];

/**
 * Tipos descontinuados: ya no se pueden crear ni aparecen en los filtros, pero se
 * conservan sus etiquetas para las contrataciones históricas que aún los usan.
 */
export const LEGACY_CONTRACT_TYPES = [{ label: 'POP blando', value: 'pop_blando', color: 'red' }];

const ALL_CONTRACT_TYPES = [...CONTRACT_TYPES, ...LEGACY_CONTRACT_TYPES];

/** Devuelve el tipo (label + color) de una contratación, incluyendo los descontinuados. */
export function getContractType(value) {
    return ALL_CONTRACT_TYPES.find((type) => type.value === value) || { label: value || 'N/A', value, color: 'default' };
}

/** Etiqueta legible del tipo de contratación. */
export function getContractTypeLabel(value) {
    return getContractType(value).label;
}

/** Opciones para los filtros de tablas (`{ text, value }`). */
export const CONTRACT_TYPE_FILTERS = CONTRACT_TYPES.map((type) => ({ text: type.label, value: type.value }));
